module.exports = __webpack_public_path__ + "assets/img/994a-cg.svg";